import React from 'react';
import { connect } from 'react-redux';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import _find from 'lodash/find';
import PropTypes from 'prop-types';
// Core components
import Link from 'components/core/Link';
import Tooltip from 'components/core/Tooltip';
// Models
import { title } from 'models/deviceBatch';
// Custom
import { deviceBatchDataShape } from 'constants/PropTypesShapes';
import { showDeviceBatchesPath } from 'production/navigation';

const DeviceBatchIdLink = ({ deviceBatch }) => {
  if (deviceBatch) {
    return (
      <div className="d-flex align-items-center">
        <Tooltip
          content={<LocalizedMessage id="tooltip.clickToAccess" values={{ resource: 'deviceBatch' }} />}
          inheritStyle={false}
          className="text-truncate"
        >
          <Link path={showDeviceBatchesPath(deviceBatch.id)}>{title(deviceBatch)}</Link>
        </Tooltip>
      </div>
    );
  }
  return null;
};

DeviceBatchIdLink.propTypes = {
  deviceBatchId: PropTypes.number.isRequired, // eslint-disable-line react/no-unused-prop-types
  deviceBatch: deviceBatchDataShape,
};

DeviceBatchIdLink.defaultProps = {
  deviceBatch: null,
};

const mapStateToProps = (state, ownProps) => ({
  deviceBatch: _find(state.deviceBatch.list.elements.data, ['id', ownProps.deviceBatchId]),
});

module.exports = connect(mapStateToProps)(DeviceBatchIdLink);



// WEBPACK FOOTER //
// ./routes/app/routes/production/assets/deviceBatch/DeviceBatchIdLink.js